import { AmortizationType } from '@willow/graphql-iso/src/app';

export const formatAmortizationType = (loanType: AmortizationType): string => {
  switch (loanType) {
    case 'fixed':
      return 'Fixed';
    case 'arm':
      return 'Adjustable';
    default:
      return 'N/A';
  }
};
